import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dj_window_block1" }
const _hoisted_2 = { class: "dj_window_block1_l" }
const _hoisted_3 = {
  key: 0,
  class: "zcjd clearfix"
}
const _hoisted_4 = ["onClick"]

import { getNewsContentList } from '@/config/request';
import { ref, toRefs, watchEffect } from 'vue';
import { useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'news',
  props: {
    title: String,
    newsTypeId: String,
},
  setup(__props) {

const router = useRouter()
const props = __props
const { title,newsTypeId } = toRefs(props)

let dataList = ref([]) as any
const showDetail = (item:any) => {
    router.push({
        path: '/news-detail',
        query:{
            id: item.id
        }
    })
}
const toNewsList = () => {
    let param = {
        themeId: newsTypeId?.value,
        typeName: title?.value
    }
    router.push({
        path: '/news-list',
        query: param
    })
}
const init = async() => {
    let param = {
        themeId: newsTypeId?.value,
        typeName: title?.value
    }
    
    const res = await getNewsContentList(param) as any

    const result = res.result?.records || []
    if(result.length > 5){
        dataList.value = result.slice(0, 5)
    }else{
        dataList.value = result
    }
}

watchEffect(()=>{
    let id = newsTypeId?.value
    if(id){
        init()
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", { class: "t2_title_ny" }, [
        _createElementVNode("a", { onClick: toNewsList }, [...(_cache[0] || (_cache[0] = [
          _createTextVNode("查看更多", -1),
          _createElementVNode("i", { class: "leftAndright" }, null, -1)
        ]))]),
        _cache[1] || (_cache[1] = _createElementVNode("span", null, "党建要闻", -1))
      ]),
      (_unref(newsTypeId))
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id,
                onClick: ($event: any) => (showDetail(item))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", null, _toDisplayString(item.title), 1),
                  _createElementVNode("p", null, _toDisplayString(item.releaseDate), 1)
                ])
              ], 8, _hoisted_4))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "dj_window_block1_r" }, [
      _createElementVNode("img", { src: "images/djimg.png" })
    ], -1))
  ]))
}
}

})